import HomeBread from '../assets/Home.svg'
import '../pages/Dashboard.css';
import Layout from "./Layout";
import { Link } from "react-router-dom";
import imageDashboard from '../assets/image.png'
import api from './api.json'
import { useEffect, useState } from 'react';

function Dashboard({ username, onSignOut, token }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const queryDev = api.pastActivity;

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const payload = {
                    "user_id": username
                }
                const response = await fetch(queryDev, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setData(result);
                console.log("✅ Past Activity Result:", result);

            } catch (err) {
                console.error("Error fetching data:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [queryDev, username, token]);


    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="">
                <div className="HomeBreadCrumb border-b-[1px] border-[#CFCFCF]">
                    <span className="HomeBreadCrumbInside">
                        <img src={HomeBread} alt="HomeBread" className="HomeBread" />
                        <span className="HomeText">Home</span>
                    </span>
                </div>
                <div className="flex flex-row">
                    <div className="w-2/3 pl-10 pt-12">
                        <div className="flex ">
                            <img src={imageDashboard} alt="imageDashboard" className="imageDashboard w-[16%]" />
                            <div className="pl-4 flex flex-col justify-center gap-2">
                                <span className="font-semibold text-4xl text-[#A100FF]">
                                    <span className="pr-2">Hi</span>
                                    <span>{username}!</span>
                                </span>
                                <span className="font-semibold text-[28px] leading-[34px] text-[#000000]">Welcome to AuracostAI </span>
                            </div>
                        </div>
                        <div className="border rounded-2xl  border-[#F1F1EF] mt-[42px]">
                            <div className="pt-[17px] pl-[20px] gap-[10px] font-semibold text-sm pb-[21px]">
                                How May I Assist you ?
                            </div>
                            <div className="pl-[24px] pb-6 pr-6">
                                <div className="grid grid-cols-2 gap-6">
                                    <Link to='/LandingPage'>
                                        <div className="bg-[#F4F3FF] rounded-xl p-4 border-2 border-transparent hover:border-2 hover:border-[#7500C0]">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M2 22V2H22V18H6L2 22ZM4 16H20V4H4V16Z" fill="black" />
                                            </svg>
                                            <h2 className="CardHeading">Should Cost Modeling</h2>
                                            <p className="CardBody">Create a new Should Cost from Scratch</p>
                                        </div>
                                    </Link>
                                    <Link to='/Overview'>
                                        <div className="rounded-xl p-4 bg-[#F4F3FF] border-2 border-transparent hover:border-2 hover:border-[#7500C0]">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M19 5V7H15V5H19ZM9 5V11H5V5H9ZM19 13V19H15V13H19ZM9 17V19H5V17H9ZM21 3H13V9H21V3ZM11 3H3V13H11V3ZM21 11H13V21H21V11ZM11 15H3V21H11V15Z" fill="black" />
                                            </svg>
                                            <h2 className="CardHeading">Overview Dashboard</h2>
                                            <p className="CardBody">View Spend and Savings Summary</p>
                                        </div>
                                    </Link>
                                    {/* <Link to='/Analysis'> */}
                                    <div className="tooltip-container1">
                                        <div className="pointer-events-none opacity-60 rounded-xl p-4 bg-[#F4F3FF] border-2 border-transparent hover:border-2 hover:border-[#7500C0]">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M13.5 9V11H10.5V9H8V7H10.5V1H3.5V7H6V9H3.5V15H6V17H3.5V23H10.5V17H8V15H10.5V13H13.5V15H20.5V9H13.5ZM5.5 3H8.5V5H5.5V3ZM8.5 21H5.5V19H8.5V21ZM8.5 13H5.5V11H8.5V13ZM18.5 13H15.5V11H18.5V13Z" fill="black" />
                                            </svg>
                                            <h2 className="CardHeading">What-if Analysis</h2>
                                            <p className="CardBody">Evaluate custom scenarios for cost models</p>
                                        </div>
                                        <span className="tooltip-text2">
                                            Coming soon — evaluate cost models under various assumptions!
                                        </span>
                                    </div>
                                    {/* </Link>
                                    <Link to='/Negotiation'> */}
                                    <div className="tooltip-container1">
                                        <div className="pointer-events-none opacity-60 rounded-xl p-4 bg-[#F4F3FF] border-2 border-transparent hover:border-2 hover:border-[#7500C0]">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M12.2201 19.8549C12.0401 20.0349 11.7201 20.0649 11.5101 19.8549C11.3301 19.6749 11.3001 19.3549 11.5101 19.1449L14.9001 15.7549L13.4901 14.3449L10.1001 17.7349C9.91009 17.9349 9.59009 17.9249 9.39009 17.7349C9.18009 17.5249 9.21009 17.2049 9.39009 17.0249L12.7801 13.6349L11.3701 12.2249L7.98009 15.6149C7.80009 15.7949 7.48009 15.8249 7.27009 15.6149C7.08009 15.4249 7.08009 15.1049 7.27009 14.9049L10.6601 11.5149L9.24009 10.1049L5.85009 13.4949C5.67009 13.6749 5.35009 13.7049 5.14009 13.4949C4.95009 13.2949 4.95009 12.9849 5.14009 12.7849L9.52009 8.40488L11.3901 10.2649C12.3401 11.2149 13.9801 11.2049 14.9301 10.2649C15.9101 9.28488 15.9101 7.70488 14.9301 6.72488L13.0701 4.86488L13.3501 4.58488C14.1301 3.80488 15.4001 3.80488 16.1801 4.58488L20.4201 8.82488C21.2001 9.60488 21.2001 10.8749 20.4201 11.6549L12.2201 19.8549ZM21.8301 13.0749C23.3901 11.5149 23.3901 8.98488 21.8301 7.41488L17.5901 3.17488C16.0301 1.61488 13.5001 1.61488 11.9301 3.17488L11.6501 3.45488L11.3701 3.17488C9.81009 1.61488 7.28009 1.61488 5.71009 3.17488L2.17009 6.71488C0.750092 8.13488 0.620092 10.3449 1.77009 11.9049L3.22009 10.4549C2.83009 9.70488 2.96009 8.75488 3.59009 8.12488L7.13009 4.58488C7.91009 3.80488 9.18009 3.80488 9.96009 4.58488L13.5201 8.14488C13.7001 8.32488 13.7301 8.64488 13.5201 8.85488C13.3101 9.06488 12.9901 9.03488 12.8101 8.85488L9.52009 5.57488L3.72009 11.3649C2.74009 12.3349 2.74009 13.9249 3.72009 14.9049C4.11009 15.2949 4.61009 15.5349 5.14009 15.6049C5.21009 16.1249 5.44009 16.6249 5.84009 17.0249C6.24009 17.4249 6.74009 17.6549 7.26009 17.7249C7.33009 18.2449 7.56009 18.7449 7.96009 19.1449C8.36009 19.5449 8.86009 19.7749 9.38009 19.8449C9.45009 20.3849 9.69009 20.8749 10.0801 21.2649C10.5501 21.7349 11.1801 21.9949 11.8501 21.9949C12.5201 21.9949 13.1501 21.7349 13.6201 21.2649L21.8301 13.0749Z" fill="black" />
                                            </svg>
                                            <h2 className="CardHeading">Negotiation Strategy​</h2>
                                            <p className="CardBody">Define tailored fact-based negotiation approach​</p>
                                        </div>
                                        <span className="tooltip-text2">
                                            Coming soon — build fact-based negotiation strategies!
                                        </span>
                                    </div>
                                    {/* </Link> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="w-[29%] ml-6 mt-12 border rounded-2xl border-[#F1F1EF] pl-4 pt-4 flex flex-col">
                        <div className="flex justify-between items-center">
                            <span className="TextActivity">Your Activities</span>
                            <Link to="/summary" state={{ activities: data }}>
                                <span className="TextView cursor-pointer hover:bg-[#E6DCFF] flex items-center gap-1">
                                    <span className="TextViewAll">View All</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                    >
                                        <path
                                            d="M10 5L9.11917 5.88167L12.6067 9.375H5V10.625H12.6067L9.11917 14.1192L10 15L15 10L10 5Z"
                                            fill="#A100FF"
                                        />
                                    </svg>
                                </span>
                            </Link>
                        </div>

                        {loading || error || !data || data.length === 0 ? (
                            <div className="flex-1 flex flex-col items-center justify-center text-center gap-1">
                                {loading && <div>Loading activities...</div>}
                                {error && <span className="TextNoActivity text-red-500">Error: {error}</span>}
                                {!loading && !error && data?.length === 0 && (
                                    <>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="84"
                                            height="92"
                                            viewBox="0 0 84 92"
                                            fill="none"
                                        >
                                            <path
                                                opacity="0.3"
                                                d="M29.6654 64.7506C29.6654 49.834 41.832 37.6673 56.7487 37.6673C60.457 37.6673 63.957 38.4173 67.1654 39.7507V16.834H58.832V29.334H17.1654V16.834H8.83203V75.1673H31.7487C30.4154 71.959 29.6654 68.459 29.6654 64.7506Z"
                                                fill="#A100FF"
                                            />
                                            <path
                                                d="M31.75 75.167H8.83333V16.8337H17.1667V29.3337H58.8333V16.8337H67.1667V39.7503C70.2917 41.042 73.0833 42.917 75.5 45.2503V16.8337C75.5 12.2503 71.75 8.50033 67.1667 8.50033H49.75C48 3.66699 43.4167 0.166992 38 0.166992C32.5833 0.166992 28 3.66699 26.25 8.50033H8.83333C4.25 8.50033 0.5 12.2503 0.5 16.8337V75.167C0.5 79.7503 4.25 83.5003 8.83333 83.5003H37.25C34.9583 81.0837 33.0417 78.292 31.75 75.167ZM38 8.50033C40.2917 8.50033 42.1667 10.3753 42.1667 12.667C42.1667 14.9587 40.2917 16.8337 38 16.8337C35.7083 16.8337 33.8333 14.9587 33.8333 12.667C33.8333 10.3753 35.7083 8.50033 38 8.50033Z"
                                                fill="#A100FF"
                                            />
                                            <path
                                                d="M72.5833 74.75C74.25 71.8333 75.5 68.5 75.5 64.75C75.5 54.3333 67.1667 46 56.75 46C46.3333 46 38 54.3333 38 64.75C38 75.1667 46.3333 83.5 56.75 83.5C60.5 83.5 63.8333 82.25 66.75 80.5833L78 91.8333L83.8333 86L72.5833 74.75ZM56.75 75.1667C50.9167 75.1667 46.3333 70.5833 46.3333 64.75C46.3333 58.9167 50.9167 54.3333 56.75 54.3333C62.5833 54.3333 67.1667 58.9167 67.1667 64.75C67.1667 70.5833 62.5833 75.1667 56.75 75.1667Z"
                                                fill="#A100FF"
                                            />
                                        </svg>
                                        <span className="TextNoActivity">No Recent Activities to display</span>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="w-full">
                                {data.map((item, index) => (
                                    <div
                                        key={index}
                                        className="flex justify-between items-center !py-2 !pl-1 !pr-4"
                                    >
                                        <p className="text-sm font-medium text-[#7500C0]">
                                            {item["Part ID"] || "N/A"}
                                        </p>
                                        <p className="text-sm font-medium text-[#7500C0]">
                                            {item["BU"] || "N/A"}
                                        </p>
                                        

                                        {/* <p
                                            className={`text-sm font-semibold ${item["Negotiation_Status"]?.toLowerCase() === "successful"
                                                    ? "text-green-600"
                                                    : "text-orange-600"
                                                }`}
                                        >
                                            {item["Negotiation_Status"] || "Pending"}
                                        </p> */}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                </div>
            </div >
        </Layout >
    )
}
export default Dashboard;
